import PropTypes from 'prop-types';
import React from 'react';
import { accountActions } from 'core/Account';
import { config } from 'config';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    Avatar,
    Dropdown
} from 'mol-ui';
import {
    useDispatch,
    useSelector,
    useWindowSize
} from 'hooks';
const { ssoLogin } = config;

const UserMenu = ({
    avatar,
    userName
}) => {

    const dispatch = useDispatch();
    const { push } = useHistory();
    const { overPrimaryColor } = useTheme();
    const { t } = useTranslation();
    const { xs } = useWindowSize();

    const { user } = useSelector('account');
    const roles = user?.roles ?? [];

    const options = [{
        display: ssoLogin && roles.length > 1,
        icon: 'open_in_new',
        label: t('Cambiar perfil'),
        onClick: () => dispatch(accountActions.setAccountRoleSelector(true))
    }, {
        display: !ssoLogin,
        label: t('Editar perfil'),
        onClick: () => push(t('/perfil'))
    }, {
        label: t('Salir'),
        onClick: () => dispatch(accountActions.accountLogoutModalToggle())
    }];

    return (
        <>
            <Avatar
                margin="0px 10px"
                size={ 50 }
                src={ avatar }
            />
            <Dropdown
                color={ overPrimaryColor }
                options={ options }
                size={ 25 }
                text={ !xs ? userName : '' }
                top="18px"
            />
        </>
    );
};

UserMenu.propTypes = {
    avatar: PropTypes.string,
    userName: PropTypes.string
};

export default UserMenu;
